import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.settings.pin.success.title',
        defaultMessage: 'Done!',
    },
    subtitle: {
        id: 'modal.settings.pin.success.sub_title',
        defaultMessage: 'Card PIN has been updated',
    },
    button: {
        id: 'modal.settings.pin.success.button',
        defaultMessage: 'Got it',
    },
})
